import React, { useContext, useEffect, useRef, useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { ApiContext } from '@api/api';
import { dayjsFromApiUtcInTz, formatDateFromDayjsWithLocale } from '@utils/dateWithTz.tsx';
import ThreadPanel from './ThreadPanel';
import { EntityTypeEnum } from '@api/ringil-api.v2';
import { SecuredConfig, useSecuredDecoration } from '@components/security/securedDecoration';
import { sidebarTransitionOptions } from '@components/ringil3/Sidebar/sidebarTransition.ts';

interface ComponentProps {
  companyId: string;
  entityId: string;
  entityType: EntityTypeEnum;
  visible: boolean;
  onHide: () => void;
  customerName: string;
  readOnly?: boolean;
  secured?: SecuredConfig;
}

const CarrierChatComponent: React.FC<ComponentProps> = ({ companyId, entityId, entityType, visible, onHide, customerName, readOnly = false, secured }) => {
  const [messages, setMessages] = useState(undefined);
  const { caGetMessagesV2 } = useContext(ApiContext);
  const { decorate } = useSecuredDecoration(secured);
  const messagesEndRef = useRef(null);

  const reload = () => {
    caGetMessagesV2(companyId, entityId, entityType, data => {
      setMessages(
        data.messages.reduce((r, a) => {
          r[formatDateFromDayjsWithLocale(dayjsFromApiUtcInTz(a.created, 'Europe/Prague'))] = [...(r[formatDateFromDayjsWithLocale(dayjsFromApiUtcInTz(a.created, 'Europe/Prague'))] || []), a];
          return r;
        }, {} as any),
      );
    });
  };

  useEffect(() => {
    reload();
  }, []);

  useEffect(() => {
    if (messagesEndRef && messagesEndRef.current) messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <>{decorate(
      <>
      {/*//
      @ts-ignore*/}
      <Sidebar transitionOptions={sidebarTransitionOptions}
        visible={visible}
        position="right"
        baseZIndex={1000000}
        onHide={() => onHide()}
        className="sidebar-modal-chat sidebar-modal-lg sidebar-modal-chat-carrier"
      >
        <ThreadPanel entityType={entityType} entityId={entityId} companyId={companyId} readOnly={readOnly} />
      </Sidebar>
      </>,
    )}</>
  );
};

export default CarrierChatComponent;
